import { Fragment } from "react";
import { BeatLoader } from "react-spinners";

const BeatSpinner = () => {
  return (
    <Fragment>
      <BeatLoader color="white" size={10} />
    </Fragment>
  );
};

export default BeatSpinner;
